import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close } from '@otp/icons';
import { Chip } from '../chip';
import styles from './multi-select-selected-tags.module.css';
export const DEFAULT_CHIP_PROPS = {
    size: 'small',
    color: 'primary',
    'data-testid': 'selected-value',
};
export const MultiSelectSelectedTags = ({ value, getTagProps, limitTags = Infinity, }) => {
    const numTags = (value === null || value === void 0 ? void 0 : value.length) || 0;
    return (_jsxs("div", { className: styles.wrapper, children: [value.slice(0, limitTags).map((option, index) => {
                var _a;
                const tagProps = getTagProps({ index });
                const optionOptions = (_a = value[index]) === null || _a === void 0 ? void 0 : _a.options;
                const calculatedTagProps = Object.assign(Object.assign(Object.assign({}, DEFAULT_CHIP_PROPS), { 
                    // @ts-ignore
                    color: (optionOptions === null || optionOptions === void 0 ? void 0 : optionOptions.color) || DEFAULT_CHIP_PROPS.color }), tagProps);
                return (_createElement(Chip, Object.assign({}, calculatedTagProps, { key: index, label: typeof option === 'string' ? option : option === null || option === void 0 ? void 0 : option.name, deleteIcon: _jsx(Close, {}) })));
            }), numTags > limitTags && (_jsx(Chip, Object.assign({}, DEFAULT_CHIP_PROPS, { label: `+${numTags - limitTags}` })))] }));
};
export default MultiSelectSelectedTags;
